module.exports = __webpack_public_path__ + "img/2025-05-09d_3.ffea6ee1.jpg";